__turbopack_context__.v({
  "accordionContent": "KldBwa_accordionContent",
  "accordionControl": "KldBwa_accordionControl",
  "accordionItem": "KldBwa_accordionItem",
  "accordionItemSummary": "KldBwa_accordionItemSummary",
  "accordionItemSummaryFlex": "KldBwa_accordionItemSummaryFlex",
  "accordionWrapper": "KldBwa_accordionWrapper",
  "opened": "KldBwa_opened",
});
